import { createSelector } from 'reselect';
import { isTestTargetReadySelector } from 'viewModel/selectors/testTarget/isTestTargetReadySelector';
import { experienceSelector } from 'selectors/testTarget/offers/updateBIAButtonTreatment/experience/experienceSelector';
import { UPDATE_BIA_BUTTON_TREATMENT } from 'constants/TestTarget';

const showUpdateBIAButtonTreatmentSelector = createSelector(isTestTargetReadySelector, experienceSelector, (testReady, experience) => ({
    challengerOne: testReady && experience === UPDATE_BIA_BUTTON_TREATMENT.CHALLENGER_ONE,
    challengerTwo: testReady && experience === UPDATE_BIA_BUTTON_TREATMENT.CHALLENGER_TWO,
    challengerThree: testReady && experience === UPDATE_BIA_BUTTON_TREATMENT.CHALLENGER_THREE
}));

export { showUpdateBIAButtonTreatmentSelector };
